export * from './src/events-schedule-v1-schedule-item-schedule.universal.js';
